import BankAccounts from './BankAccounts'

export default BankAccounts
